"use strict";
module.exports = entity => {
    const ensuredEntity = {
        ...entity,
    };
    ensuredEntity.cartRows = (ensuredEntity.cartRows || []).filter(cartRow => (cartRow.quantity || 0) > 0);
    return ensuredEntity;
};
